import {useMemo} from "react";

import {ToolCategories} from "../ai-tools-list.ts";

/**
 * Custom hook to determine the categories to render based on the tools state.
 *
 * @param {Array} fullToolsState - The complete list of tools.
 * @returns {Array} - List of categories to render.
 */

const useCategoriesToRender = (fullToolsState) => {
    return useMemo(() => {
        if (!fullToolsState.length) {
            return [];
        }

        const toolCategories = new Set([ToolCategories.All]);
        fullToolsState.forEach((tool) => {
            toolCategories.add(tool.categories[0]);
            toolCategories.add(ToolCategories.Favorites);
        });

        const categories = Array.from(toolCategories);
        const allCategories = Object.values(ToolCategories);

        return categories.sort((a, b) => {
            if (a === ToolCategories.Favorites) {
                return -1;
            }
            if (b === ToolCategories.Favorites) {
                return 1;
            }
            return allCategories.indexOf(a) - allCategories.indexOf(b);
        });
    }, [fullToolsState]);
};

export default useCategoriesToRender;
